
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { ref, onMounted, computed, reactive, toRefs, h, watch } from "vue";

const highlightOwnName = (div: any) => {
    var inputText = $(div).find(".pub_author")[0];
    console.log(inputText);

    var innerHTML = inputText.innerHTML;
    var text = "Aoyu Wu";
    var index = innerHTML.indexOf(text);
    if (index >= 0) {
        innerHTML =
            innerHTML.substring(0, index) +
            "<span class='pub_author_me'>" +
            innerHTML.substring(index, index + text.length) +
            "</span>" +
            innerHTML.substring(index + text.length);
    }
    inputText.innerHTML = innerHTML;
};

export default defineComponent({
    name: "App",
    props: ["publication"],
    components: {},
    setup(props) {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });
        const pub = ref(null);

        onMounted(() => {
            highlightOwnName(pub.value);
        });

        return {
            ...toRefs(state),
            pub,
        };
    },
    computed: {},
});
